import React from 'react'

import { FeatureScope } from '@/types/billing'

import { useCheckFeaturePermission } from './useCheckFeaturePermission'

export interface CheckFeaturePermissionProps {
	children: ({ isLoading, isPermitted }: { isLoading: boolean; isPermitted: boolean }) => React.ReactElement
	requiredFeature?: FeatureScope
}

export function CheckFeaturePermission({ children, requiredFeature }: CheckFeaturePermissionProps) {
	const permissionData = useCheckFeaturePermission()(requiredFeature)

	return children(permissionData)
}
